import storageApi from "../api/storageApi";
import userStore from "../store/userStore";

const { default: basketApi } = require("../api/basketApi");
const { default: basketStore } = require("../store/basketStore");

class ApiHelpers {
  isStorageGetted = false;
  // получение и запись корзины
  async getAndSetUserBasket(signal) {
    try {
      // не исплользуем abortController т.к. он должен использоваться внутри компонента
      const data = await basketApi.getEvrimaBasket(signal);
      console.log("basketData: ", data);
      const basketItems = {};
      data.forEach((item) => {
        basketItems[item.shopItem.itemId] = item;
      });
      console.log("basketItems: ", basketItems);
      basketStore.setItems(basketItems);
    } catch (err) {
      console.error(err);
    }
  }

  async getAndSetUserStorage(serverId, signal) {
    if (this.isStorageGetted) return;
    try {
      const storage = await storageApi.getStorage(serverId, signal);
      console.log(storage);

      userStore.setStorage(storage);
      this.isStorageGetted = true;
    } catch (err) {
      console.error(err);
    }
  }
}

export const apiHelpers = new ApiHelpers();
